import * as React from 'react';
import {FunctionComponent, useEffect, useRef} from 'react';
import {observer} from 'mobx-react-lite';
import {FlatListForLogGenericState} from './FlatListForLogGenericState';
import {faBars, faMinus, faPlus} from '@fortawesome/free-solid-svg-icons';
import {IconDefinition} from '@fortawesome/free-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

export interface FlatDetailsStructuralActionPopoverProps {
    state: FlatListForLogGenericState;
}

interface PopoverAction {
    name: string;
    description: string;
    onClick: (state: FlatListForLogGenericState, filterElement: string) => void;
    icon: IconDefinition;
}

const actions: PopoverAction[] = [
    {
        name: 'Include',
        description: 'Show all elements with this value',
        onClick: (state: FlatListForLogGenericState, filterElement: string) => {
            state.toggleStructuralSearchArray('include:' + filterElement);
        },
        icon: faPlus,
    },
    {
        name: 'Exclude',
        description: 'Show all elements without this value',
        onClick: (state: FlatListForLogGenericState, filterElement: string) => {
            state.toggleStructuralSearchArray('exclude:' + filterElement);
        },
        icon: faMinus,
    },
    {
        name: 'All',
        description: 'Show all elements with any value in that field',
        onClick: (state: FlatListForLogGenericState, filterElement: string) => {
            state.toggleStructuralSearchArray('all:' + filterElement);
        },
        icon: faBars,
    },
];

function useOuterClick(callback: any) {
    const callbackRef = useRef(); // initialize mutable ref, which stores callback
    const innerRef = useRef(); // returned to client, who marks "border" element

    // update cb on each render, so second useEffect has access to current value
    useEffect(() => {
        callbackRef.current = callback;
    });

    useEffect(() => {
        document.addEventListener('click', handleClick);
        return () => document.removeEventListener('click', handleClick);

        function handleClick(e: any) {
            if (innerRef.current && callbackRef.current &&
                // @ts-ignore
                !innerRef.current.contains(e.target)
                // @ts-ignore
            ) callbackRef.current(e);
        }
    }, []); // no dependencies -> stable click listener

    return innerRef; // convenience for client (doesn't need to init ref himself)
}

export const FlatDetailsStructuralActionPopover: FunctionComponent<FlatDetailsStructuralActionPopoverProps> = observer((props) => {
    const innerRef = useOuterClick((ev: any) => {
        props.state.hideSearchStructuralPopover();
    });

    // @ts-ignore
    return <div ref={innerRef}
                className="max-w-sm absolute z-10 p-4 mt-3 bg-m-gray-2 border border-m-gray-1 bg-m-gray-2"
                style={{right: 60, top: props.state.structuralSearchPopoverTopPosition, left: props.state.structuralSearchPopoverLeftPosition}}>
        <div className="mb-4 truncate">
            {props.state.structuralSearchPopoverSearchElement}
        </div>
        <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
            <div className="grid grid-cols-1">
                {actions.map((item) => (
                    <button
                        key={item.name}
                        onClick={() => {
                            item.onClick(props.state, props.state.structuralSearchPopoverSearchElement);
                            props.state.hideSearchStructuralPopover();
                        }}
                        className="flex items-center p-2 transition duration-150 ease-in-out rounded-lg hover:bg-m-gray-3 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                    >
                        <div className="btn btn-primary">
                            <FontAwesomeIcon className="fill-current" icon={item.icon}/>
                        </div>
                        <div className="ml-4 text-left ">
                            <p className="text-sm font-medium text-gray-900">
                                {item.name}
                            </p>
                            <p className="text-sm text-gray-500">
                                {item.description}
                            </p>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    </div>;
});

